module.exports = __webpack_public_path__ + "img/crystals-books.65b327b0.jpeg";